import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { anticiposApi } from '@/data/api/anticiposApi';
const KEY = 'anticipos';
export function useAnticipos(filtros = {}) {
    return useQuery({
        queryKey: [KEY, filtros],
        queryFn: () => anticiposApi.listar(filtros),
        placeholderData: (previous) => previous,
    });
}
export function useCrearAnticipo() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => anticiposApi.crear(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useEliminarAnticipo() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => anticiposApi.eliminar(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
